// Replace these with your real values
const SHOPIFY_STORE_DOMAIN = 'customcribboards.myshopify.com'; // e.g. 'cool-tshirts.myshopify.com'
const STOREFRONT_ACCESS_TOKEN = 'eb672d6635ef2e11c6d0a6c4dbf47559'; // from Shopify Admin ? Apps and sales channels ? Develop apps ? your app ? API credentials ? Storefront API
const ADMIN_ACCESS_TOKEN = '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'; // Admin API access token (with read_products scope)

// Recommended: 2025-01 or newer (check https://shopify.dev/docs/api/storefront for latest stable)
const API_VERSION = '2026-01';
const GRAPHQL_ENDPOINT        = `https://${SHOPIFY_STORE_DOMAIN}/api/${API_VERSION}/graphql.json`;
const GRAPHQL_ENDPOINT_ADMIN  = `https://${SHOPIFY_STORE_DOMAIN}/admin/api/${API_VERSION}/graphql.json`;

/*
const client = createGraphQLClient({
  url: GRAPHQL_ENDPOINT,
  headers: {
    'X-Shopify-Access-Token': STOREFRONT_ACCESS_TOKEN,
    // 'Content-Type': 'application/json' is usually added automatically
  },
  retries: 2,           // optional: auto-retry on 429 or network errors
  fetchApi: fetch,      // optional: if running in Node 18+, use native fetch; otherwise import node-fetch
});

console.log('createGraphQLClient client', client);
*/

// Define your GraphQL query (same as previous examples)
const GET_PRODUCTS_QUERY = `
  query GetProductsPaginated($first: Int!, $after: String, $query: String) {
    products(first: $first, after: $after, query: $query, sortKey: TITLE, reverse: false) {
      edges {
        cursor
        node {
          id
          title
          handle
          description
          tags
          featuredImage {
            url
            altText
          }
          variants(first: 20) {
            edges {
              node {
                id
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode                  
                }
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;


// Helper to make a GraphQL request
async function shopifyFetch(query, variables = {}) {
  const response = await fetch(GRAPHQL_ENDPOINT_ADMIN, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      //'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      'X-Shopify-Access-Token': ADMIN_ACCESS_TOKEN
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const { data, errors } = await response.json();

  if (errors) {
    console.error('GraphQL Errors:', errors);
    throw new Error('GraphQL query failed');
  }

  return data;
}


// Helper to make a GraphQL request
async function shopifyFetchAdmin(query, variables = {}) {
  const response = await fetch(GRAPHQL_ENDPOINT_ADMIN, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Access-Token': ADMIN_ACCESS_TOKEN,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const { data, errors } = await response.json();

  if (errors) {
    console.error('GraphQL Errors:', errors);
    throw new Error('GraphQL query failed');
  }

  return data;
}





async function getProducts() {
  let allProductsWithVideos = [];
  let after = null;
  const pageSize = 250; // Adjust up to ~250

  do {
    console.log("GRAPHQL_ENDPOINT", GRAPHQL_ENDPOINT);
    const response = await fetch(GRAPHQL_ENDPOINT, {  // Use your version, e.g. 2025-01 or latest
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Access-Token': STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query: `
          query FindProductsWithVideos($first: Int!, $after: String) {
            products(first: $first, after: $after) {
              edges {
                node {
                  id
                  title
                  handle
                  hostedVideos: media(first: 1, query: "media_type:VIDEO") {
                    edges { node { __typename } }  // Minimal: just check existence
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        `,
        variables: { first: pageSize, after },
      }),
    });

    const { data } = await response.json();
    console.log("getProducts data", data);
    const products = data?.products?.edges || [];

    // Client-side filter
    const withVideos = products.filter(({ node }) =>
      node.hostedVideos.edges.length > 0 || node.externalVideos.edges.length > 0
    );

    allProductsWithVideos = allProductsWithVideos.concat(withVideos.map(({ node }) => node));

    after = data?.products?.pageInfo?.hasNextPage ? data.products.pageInfo.endCursor : null;
  } while (after);

  console.log(`Found ${allProductsWithVideos.length} products with videos:`);
  console.log(allProductsWithVideos);
  return allProductsWithVideos;
}




// Example: Query to fetch some products
async function getProductsOrg(queryFilter = '') {
  const queryx = `
    query GetProductsPaginated($first: Int!, $after: String, $query: String) {
      products(first: $first, after: $after, query: $query, sortKey: TITLE, reverse: false) {
        edges {
          cursor 
          node {
            id
            title
            handle
            description
            featuredImage {
              url
              altText
            }
            variants(first: 20) {
              edges {
                node {
                  id
                  price {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const query = GET_PRODUCTS_QUERY;

  let allProducts = [];
  let cursor = null;
  let hasNextPage = true;
  const pageSize = 50; // up to 250 max

  while (hasNextPage) {
    const variables = {
      first: pageSize,
      query: queryFilter || undefined, // omit if empty
    };

    if (cursor) {
      variables.after = cursor;
    }

    const data = await shopifyFetch(query, variables);
    //console.log('getProducts data', data);

    const page = data?.products;
    //console.log('getProducts page', page);
    if (!page) {
      throw new Error('No products data in response');
    }
    
    const productsThisPage = page.edges.map((edge) => edge.node);
    //console.log('getProducts productsThisPage', productsThisPage);
    allProducts = allProducts.concat(productsThisPage);

    cursor = page.pageInfo.endCursor;
    hasNextPage = page.pageInfo.hasNextPage;

  }

  //console.log('getProducts allProducts', allProducts);
  //const data = await shopifyFetch(query, { first });
  return new Promise(function (resolve, reject) {
    resolve(allProducts);
  });  

}


// Optional: Example mutation (create checkout / add to cart)
async function createCheckout(variantId, quantity = 1) {
  const mutation = `
    mutation checkoutCreate($input: CheckoutCreateInput!) {
      checkoutCreate(input: $input) {
        checkout {
          id
          webUrl
        }
        checkoutUserErrors {
          code
          field
          message
        }
      }
    }
  `;

  const variables = {
    input: {
      lineItems: [{ variantId, quantity }],
    },
  };

  const data = await shopifyFetch(mutation, variables);
  const { checkout, checkoutUserErrors } = data.checkoutCreate;

  if (checkoutUserErrors?.length > 0) {
    console.error('Checkout errors:', checkoutUserErrors);
    throw new Error('Failed to create checkout');
  }

  return checkout;
}


// Async function to fetch all (or paginated) products
async function fetchAllProducts(queryFilter = '') {  // e.g. "tag:sale" or ""
  let allProducts = [];
  let cursor = null;
  let hasNextPage = true;
  const pageSize = 50; // up to 250 max

  while (hasNextPage) {
    const variables = {
      first: pageSize,
      query: queryFilter || undefined, // omit if empty
    };

    if (cursor) {
      variables.after = cursor;
    }

    try {
      const response = await client.request(GET_PRODUCTS_QUERY, variables);
      console.log('fetchAllProducts response', response);

      const page = response.data?.products;
      if (!page) {
        throw new Error('No products data in response');
      }
      
      const productsThisPage = page.edges.map((edge) => edge.node);
      console.log('fetchAllProducts productsThisPage', productsThisPage);
      allProducts = allProducts.concat(productsThisPage);

      cursor = page.pageInfo.endCursor;
      hasNextPage = page.pageInfo.hasNextPage;

      console.log(`Fetched ${productsThisPage.length} products (total: ${allProducts.length}) — hasNext: ${hasNextPage}`);
    } catch (error) {
      console.error('GraphQL request failed:', error);
      throw error; // or handle retries/custom logic
    }
  }

  return allProducts;
}

/*
{
  "id": "gid://shopify/Product/123456789",
  "tags": ["old-tag"]
}
*/
async function removeProductTags(productId, tags) {
  const mutation = `
    mutation productTagsRemove($id: ID!, $tags: [String!]!) {
      tagsRemove(id: $id, tags: $tags) {
        userErrors {
          field
          message
        }
        taggedResource {
          ... on Product {
            id
            tags
          }
        }
      }
    }
  `;

  const variables = {
    id: productId,
    tags: tags
  };

  const data = await shopifyFetch(mutation, variables);
  const { taggedResource, userErrors } = data.tagsRemove;

  if (userErrors?.length > 0) {
    console.error('Update product tags errors:', userErrors);
    throw new Error('Failed to update product tags');
  }

  return taggedResource;
} 


async function addProductTags(productId, tags) {
  //console.log('addProductTags params', productId, tags);

  const mutation = `
    mutation addTags($id: ID!, $tags: [String!]!) {
      tagsAdd(id: $id, tags: $tags) {
        node {
          id
          ... on Product {
            tags
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const variables = {
    id: productId,
    tags: tags
  };

  console.log('addProductTags variables', variables);

  const data = shopifyFetchAdmin(mutation, variables);
  console.log('addProductTags data', data);
  const node = data.node;
  const userErrors = data.userErrors;

  if (userErrors?.length > 0) {
    console.error('addProductTags add tags errors:', userErrors);
    throw new Error('Failed to add product tags');
  }

  return { node, userErrors };
} 

